<template>
  <!-- Mobile backdrop: dims screen when right drawer is open; click closes it -->
  <div v-if="mobileOpen" class="nav-rightbar-backdrop" @click="$emit('close')"></div>

  <!-- Root sidebar container; toggles 'search-mode' styling while a search is active and slides in as a drawer on mobile via 'nav-rightbar--mobile-open' -->
  <div class="nav-rightbar" :class="{ 'search-mode': isSearchActive, 'nav-rightbar--mobile-open': mobileOpen }">
    <!-- Mobile-only close button -->
    <button v-show="mobileOpen" class="nav-rightbar__mobile-close" @click="$emit('close')" aria-label="Close panel">
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"/>
      </svg>
    </button>
    <!-- Inner layout wrapper; removes padding (p-0) when the user isn't authenticated -->
    <div class="nav-rightbar__inner" :class="{ 'p-0': !isUserAuth }">
      <div class="nav-rightbar__panel">
         <!-- Static "Recommendations" header box; previously showed a dynamic communityBoxTitle (now commented out below) -->
         <div class="bg-[var(--color-header-bg-light-v2)] community-box border border-[var(--color-button-border)] py-[16px] shadow-sm flex flex-col gap-2">
          <!-- <span style="padding-top: 2px">{{ communityBoxTitle }}</span> -->
          <span style="padding-top: 2px">Recommendations</span>
        </div>
        <!-- <div class="nav-rightbar__scroll scroll-box !flex !flex-col !gap-4 h-[86vh]"> -->
        <!-- <div class="nav-rightbar__scroll scroll-box !flex !flex-col !gap-4 flex-1 min-h-0 px-4 h-[75vh]"> -->
        <!-- Scrollable body: hosts the Create Post button, Who to Follow, Discover & Join Groups, and various legacy blocks kept commented out below -->
        <div class="nav-rightbar__scroll scroll-box !flex !flex-col !gap-4 flex-1 min-h-0">
          <!-- Merged from Leftbar: Groups widget -->
          <!-- <FollowedGroups :groupsData="localOrgs" :isLoading="orgsLoading" /> -->
          <!-- Merged from Leftbar: Quick Links widget -->
          <!-- <QuickLinks /> -->
          <!-- Moved global search from Header to NavRightbar top -->
          <!-- -----comment start------ -->
          <!-- <div class="nav-rightbar__search" v-if="isUserAuth"
            style="margin-left: 7px !important; width: calc(100% - 14px) !important;">
            <BaseField v-model:value="searchText" @input="fetchSearchResults"
              class="login__field nav-rightbar__search-input" :placeholder="'Search'" isSearch isBottomBorderOnFocus />
          </div> -->
          <!-- -----comment end------ -->
          <!-- <transition name="fade">
            <div v-if="showProTip"
              class="bg-[var(--color-header-bg-light-v2)] border border-[var(--color-button-border)] rounded-2xl px-[10px] py-[10px] shadow-sm">
              <div class="pro-tip">
                <div class="flex items-center gap-2 mb-2">
                  <span class="text-xl shrink-0">
                    <!-- 💡 --
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
                      <path d="M12 14.3749C12.8333 14.3749 13.5417 14.0954 14.125 13.5364C14.7083 12.9773 15 12.2985 15 11.4999C15 10.7013 14.7083 10.0225 14.125 9.46346C13.5417 8.90443 12.8333 8.62492 12 8.62492C11.1667 8.62492 10.4583 8.90443 9.875 9.46346C9.29167 10.0225 9 10.7013 9 11.4999C9 12.2985 9.29167 12.9773 9.875 13.5364C10.4583 14.0954 11.1667 14.3749 12 14.3749ZM12 16.2916C10.6167 16.2916 9.4375 15.8244 8.4625 14.89C7.4875 13.9556 7 12.8256 7 11.4999C7 10.1742 7.4875 9.04419 8.4625 8.10981C9.4375 7.17544 10.6167 6.70825 12 6.70825C13.3833 6.70825 14.5625 7.17544 15.5375 8.10981C16.5125 9.04419 17 10.1742 17 11.4999C17 12.8256 16.5125 13.9556 15.5375 14.89C14.5625 15.8244 13.3833 16.2916 12 16.2916ZM5 12.4583H1V10.5416H5V12.4583ZM23 12.4583H19V10.5416H23V12.4583ZM11 4.79159V0.958252H13V4.79159H11ZM11 22.0416V18.2083H13V22.0416H11ZM6.4 7.427L3.875 5.10304L5.3 3.6895L7.7 6.08534L6.4 7.427ZM18.7 19.3103L16.275 16.8905L17.6 15.5728L20.125 17.8968L18.7 19.3103ZM16.25 6.13325L18.675 3.71346L20.15 5.07909L17.65 7.37909L16.25 6.13325ZM3.85 17.9208L6.375 15.5968L7.75 16.8666L5.325 19.2864L3.85 17.9208Z" 
                      :fill="isDark ? '#FFAD00' : '#001871'"/>
                    </svg>
                  </span>
                  <span class="text-[var(--color-accent-primary)] text-md font-bold">Pro Tip</span>
                </div>
                <button @click="showProTip = false" class="text-gray-400 hover:text-gray-600 transition mt-2 pr-1"
                  aria-label="Close">
                  <!-- ✖ --
                  <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.29999 9.86401L3.95999 6.19201L1.70999 9.86401H-8.78423e-06L3.18599 4.96801L-8.78423e-06 1.29938e-05H1.85399L4.19399 3.65401L6.42599 1.29938e-05H8.13599L4.96799 4.87801L8.15399 9.86401H6.29999Z" 
                    :stroke="isDark ? '#fff' : '#001871'" />
                  </svg>

                </button>
              </div>
              <p class="text-sm text-[var(--color-tip-text)] leading-relaxed break-words whitespace-normal text-left">
                When you engage respectfully, your Civility Score rises - which allows you to give real feedback to
                other posts.
              </p>
            </div>
          </transition> -->
          <!-- ----comment start----- -->
          <!-- <div class="nav-rightbar__posts">
            <div v-if="loading" class="pb-4">
              Loading...
            </div>
            <div v-else-if="searchText && noSearchResults" class="pb-4">
              <h5>No results found for "{{ noSearchResults }}"</h5>
            </div>
            <div v-else-if="!searchText && posts.length && !allUsers.length && !allPosts.length"
              class="nav-rightbar__posts-list nav-rightbar__suggested-block">
              <h4
                class="nav-rightbar__title text-left px-4 pt-4 text-foregroundPrimary text-sm mb-3 font-semibold tracking-wide">
                Suggested for you
              </h4> -->
          <!-- Restore SuggestedPost components with correct props -->
          <!-- <div>
            <div v-for="el in posts" :key="el.id" class="suggested-wrapper">
              <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData" :new-tab="false"></SuggestedPost>
            </div>
          </div> -->

          <!-- <div v-else-if="allUsers.length || allPosts.length || allGroups.length" class="accordion-results"> -->
          <!-- People Accordion -->
          <!-- <div v-if="allUsers.length" class="accordion-section">
                <button class="accordion-header" @click="toggleAccordion('people')">
                  <span>People Results ({{ allUsers.length }})</span>
                  <span class="chevron" :class="{ open: accordion.people }">›</span>
                </button>
                <transition name="fade-slide">
                  <div v-show="accordion.people" class="accordion-body" :ref="el => setAccordionBodyRef('people', el)">
                    <div class="nav-rightbar__posts-list nav-rightbar__suggested-block slim people-list"
                      @scroll="handleUsersScroll">
                      <div v-for="el in displayedUsers" :key="el.id" class="suggested-wrapper">
                        <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData" :new-tab="false" />
                      </div>
                      <div class="text-center mt-2" v-if="usersLoading">
                        <ProgressSpinner style="width: 34px; height: 34px; margin: 0 auto" strokeWidth="4"
                          fill="transparent" animationDuration="1.2s" aria-label="Loading users" />
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
              Posts Accordion
              <div v-if="allPosts.length" class="accordion-section">
                <button class="accordion-header" @click="toggleAccordion('posts')">
                  <span>Post Results ({{ allPosts.length }})</span>
                  <span class="chevron" :class="{ open: accordion.posts }">›</span>
                </button>
                <transition name="fade-slide">
                  <div v-show="accordion.posts" class="accordion-body" :ref="el => setAccordionBodyRef('posts', el)">
                    <div class="nav-rightbar__posts-list nav-rightbar__suggested-block slim" @scroll="handlePostsScroll">
                      <div v-for="post in displayedPosts" :key="post.id">
                        <SuggestedPostCompact :post="post" />
                      </div>
                      <div class="text-center mt-2" v-if="postsLoading">
                        <ProgressSpinner style="width: 34px; height: 34px; margin: 0 auto" strokeWidth="4"
                          fill="transparent" animationDuration="1.2s" aria-label="Loading posts" />
                      </div>
                    </div>
                  </div>
                </transition>
              </div> -->
          <!-- Groups Accordion -->
          <!-- <div v-if="allGroups.length" class="accordion-section">
                <button class="accordion-header" @click="toggleAccordion('groups')">
                  <span>Group Results ({{ allGroups.length }})</span>
                  <span class="chevron" :class="{ open: accordion.groups }">›</span>
                </button>
                <transition name="fade-slide">
                  <div v-show="accordion.groups" class="accordion-body" :ref="el => setAccordionBodyRef('groups', el)">
                    <div class="nav-rightbar__posts-list nav-rightbar__suggested-block slim groups-list">
                      <div v-for="group in limitedGroups" :key="group.id" class="suggested-wrapper group-wrapper">
                        <div class="flex items-start w-full gap-2">
                          <div class="flex-shrink-0">
                            <img :src="groupAvatar(group)" alt="group avatar"
                              class="w-10 h-10 rounded-full object-cover group-avatar" />
                          </div>
                          <div class="flex-1 min-w-0">
                            <div class="flex items-center gap-1">
                              <RouterLink :to="'/group/' + group.id" class="group-name-link truncate">{{ group.name }}
                              </RouterLink>
                            </div>
                            <div class="group-username text-xs opacity-70 truncate">
                              <RouterLink :to="'/group/' + group.id" class="hover:underline">@{{ groupHandle(group) }}
                              </RouterLink>
                            </div>
                            <div v-if="group.description" class="group-desc mt-1">{{ formatGroupDesc(group.description)
                            }}</div>
                          </div>
                          <div class="flex-shrink-0 ml-1">
                            <button class="follow-btn" @click.prevent="toggleFollowGroup(group)">
                              <span v-if="followingGroupIds.has(group.channelId || group.id)">Following</span>
                              <span v-else>Follow</span>
                            </button>
                          </div>
                        </div>
                      </div>
                      <div v-if="allGroups.length > groupPageSize" class="show-more-wrapper">
                        <button class="show-more-btn" @click="showMoreGroups = !showMoreGroups">
                          {{ showMoreGroups ? 'Show less' : 'Show more' }}
                        </button>
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
            <div v-else class="pb-4">
              <h5>No data available</h5>
            </div>
          </div> -->
          <!-- --------comment end-------->
          <!-- Old Suggestion Group code  -->
          <!-- <div v-if="allGroups.length" class="accordion-section">
            <button class="accordion-header" @click="toggleAccordion('groups')">
              <span>Group Results ({{ allGroups.length }})</span>
              <span class="chevron" :class="{ open: accordion.groups }">›</span>
            </button>
            <transition name="fade-slide">
              <div v-show="accordion.groups" class="accordion-body" :ref="el => setAccordionBodyRef('groups', el)">
                <div class="nav-rightbar__posts-list nav-rightbar__suggested-block slim groups-list">
                  <div v-for="group in limitedGroups" :key="group.id" class="suggested-wrapper group-wrapper">
                    <div class="flex items-start w-full gap-2">
                      <div class="flex-shrink-0">
                        <img :src="groupAvatar(group)" alt="group avatar"
                          class="w-10 h-10 rounded-full object-cover group-avatar" />
                      </div>
                      <div class="flex-1 min-w-0">
                        <div class="flex items-center gap-1">
                          <RouterLink :to="'/group/' + group.id" class="group-name-link truncate">{{ group.name }}
                          </RouterLink>
                        </div>
                        <div class="group-username text-xs opacity-70 truncate">
                          <RouterLink :to="'/group/' + group.id" class="hover:underline">@{{ groupHandle(group) }}
                          </RouterLink>
                        </div>
                        <div v-if="group.description" class="group-desc mt-1">{{ formatGroupDesc(group.description)
                        }}</div>
                      </div>
                      <div class="flex-shrink-0 ml-1">
                        <button class="follow-btn" @click.prevent="toggleFollowGroup(group)">
                          <span v-if="followingGroupIds.has(group.channelId || group.id)">Following</span>
                          <span v-else>Follow</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-if="allGroups.length > groupPageSize" class="show-more-wrapper">
                    <button class="show-more-btn" @click="showMoreGroups = !showMoreGroups">
                      {{ showMoreGroups ? 'Show less' : 'Show more' }}
                    </button>
                  </div>
                </div>
              </div>
            </transition>
          </div> -->
          <!-- Create Post entry point; visually disabled (dimmed, non-interactive) when the user lacks post-creation permission -->
          <BaseButton class="base-btn--small max-w-[100%] font-medium" :class="{ 'opacity-50 pointer-events-none': !canCreatePost }" @click="openCreatePost">
            + Create Post
          </BaseButton>
          <!-- "Who to Follow" card: suggested (non-celebrity) users the current user isn't already following -->
          <div
            class="bg-[var(--color-header-bg-light-v2)] border border-[var(--color-button-border)] rounded-[5px] px-[0px] py-[10px] shadow-sm flex flex-col gap-2 w-[100%]">
            <h2 class="text-base font-bold mb-1 text-[var(--color-accent-primary)] text-center">Who to Follow</h2>
            <!-- <div v-if="loading" class="flex justify-center py-3">
              <ProgressSpinner style="width: 24px; height: 24px;" strokeWidth="4" fill="transparent" animationDuration=".8s" />
            </div> -->
            <!-- Rendered only when there are non-celebrity suggested users to show -->
            <template v-if="posts?.filter((p) => p?.celebrity === false).length > 0">
              <div class="who-to-follow-scroll">
                <!-- One card per suggested user; SuggestedPost below is legacy markup kept for reference -->
                <div v-for="el in posts?.filter((p) => p?.celebrity === false)" :key="el.id"
                  class="suggested-wrapper">
                  <!-- <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData" :new-tab="false"></SuggestedPost> -->
                  <WhoToFollowCard :data="el" :isAuth="!!userData" />
                </div>
              </div>
            </template>
            <!-- Empty state: no non-celebrity suggestions and the fetch has finished -->
            <div v-if="posts?.filter((p) => p?.celebrity === false).length == 0 && loading == false" class="text-sm italic text-[var(--color-text-02)] px-2 py-2">
              No Users Found
            </div>
          </div>
          <!-- Groups to Follow: compact card matching "Who to Follow" layout -->
          <!-- Lists public groups the user hasn't joined (see suggestedGroups computed); private groups get a "Join" request flow instead -->
          <div
            class="bg-[var(--color-header-bg-light-v2)] border border-[var(--color-button-border)] rounded-[5px] px-[0px] py-[10px] shadow-sm flex flex-col gap-2 w-[100%]">
            <h2 class="text-base font-bold mb-1 text-[var(--color-accent-primary)] text-center">Discover & Join Groups</h2>
            <!-- <div v-if="orgsLoading" class="flex justify-center py-3">
              <ProgressSpinner style="width: 24px; height: 24px;" strokeWidth="4" fill="transparent" animationDuration=".8s" />
            </div> -->
            <!-- Rendered only when there are suggested groups to show -->
            <template v-if="suggestedGroups.length > 0 ">
              <div class="groups-scroll">
              <!-- One row per suggested group -->
              <div v-for="group in suggestedGroups" :key="group.id" class="suggested-wrapper">
                <!-- OLD: border-[#727272] -->
                <div class="flex items-start gap-2 border-b border-[var(--color-box-border)] p-[10px]">
                  <!-- Group avatar, links to the group page -->
                  <BaseAvatar
                    :storage-id="group.avatarFile?.storageId"
                    :href="`/group/${group.id}`"
                    isOrg
                    size="sm"
                    class="flex-shrink-0 mt-[2px]"
                  />
                  <!-- Group name + Private/Public + button -->
                  <div class="flex-1 flex flex-col justify-center items-start min-w-0 gap-[3px]">
                    <RouterLink
                      :to="`/group/${group.id}`"
                      class="block text-[13px] font-semibold hover:underline text-[var(--color-quick-link-icon-bg)] text-left w-full break-words leading-tight"
                    >{{ group.name }}</RouterLink>
                    <div class="flex items-center justify-between w-full gap-1">
                      <!-- Visibility badge: shows a lock/globe emoji plus label based on group.isPrivate -->
                      <span class="text-[0.75rem] text-[var(--color-text-02-v2)]">
                        {{ group.isPrivate ? '🔒 Private' : '🌎 Public' }}
                      </span>
                      <!-- Join (private) / Join Group (public) -->
                      <!-- Private group: sends a join request; disables and shows "Requested" once sent this session -->
                      <button
                        v-if="group.isPrivate"
                        class="follow-btn"
                        :disabled="joinRequestedIds.has(group.id)"
                        @click.prevent="handleGroupJoin(group)"
                      >{{ joinRequestedIds.has(group.id) ? 'Requested' : 'Join' }}</button>
                      <!-- old follow/unfollow buttons kept for reference -->
                      <!-- <button
                        v-else-if="followingGroupIds.has(group.channelId || group.id)"
                        class="follow-btn"
                        @click.prevent="handleGroupUnfollow(group)"
                      >Following</button>
                      <button
                        v-else
                        class="follow-btn"
                        @click.prevent="handleGroupFollow(group)"
                      >Follow</button> -->
                      <!-- Public group: join directly (same as org.vue) -->
                      <!-- Public group: joins directly and shows Join / Joining... / Joined based on request state -->
                      <button
                        v-else
                        class="follow-btn"
                        :disabled="joiningGroupIds.has(group.id) || joinedGroupIds.has(group.id)"
                        @click.prevent="handleGroupJoinPublic(group)"
                      >{{ joinedGroupIds.has(group.id) ? 'Joined' : joiningGroupIds.has(group.id) ? 'Joining...' : 'Join' }}</button>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </template>
            <!-- Empty state: no suggested groups and the orgs fetch has finished -->
            <div v-if="suggestedGroups.length == 0 && orgsLoading == false" class="text-sm italic text-[var(--color-text-02)] px-2 py-2">
              No Groups Found
            </div>
          </div>

          <!-- <div
            class="bg-[var(--color-header-bg-light)] border border-[var(--color-button-border)] rounded-2xl px-[10px] py-[10px] shadow-sm flex flex-col gap-2">
            <h2 class="text-base font-bold mb-3 text-[var(--color-accent-primary)] text-left">Civil Voices</h2>
            <div v-for="el in posts?.filter((p) => p?.celebrity === true).slice(0, 4)" :key="el.id"
              class="suggested-wrapper">
              <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData" :new-tab="false"></SuggestedPost>
            </div>
          </div> -->
          <!-- <div
            class="bg-[var(--color-header-bg-light-v2)] border border-[var(--color-button-border)] rounded-[5px] px-[0px] py-[10px] shadow-sm flex flex-col gap-2 w-[100%]">
            <h2 class="text-base font-bold mb-1 text-[var(--color-accent-primary)] text-center">Civil Voices</h2>
            <!-- <div v-if="loading" class="flex justify-center py-3">
              <ProgressSpinner style="width: 24px; height: 24px;" strokeWidth="4" fill="transparent" animationDuration=".8s" />
            </div> --
            <!-- Check if there are any celebrity users --
            <template v-if="posts?.filter((p) => p?.celebrity === true).length > 0 && loading == false">
              <div class="civil-voices-scroll">
                <div v-for="el in posts?.filter((p) => p?.celebrity === true)" :key="el.id"
                  class="suggested-wrapper">
                  <SuggestedPost :data="el" :type="'user'" :gap="0" :isAuth="!!userData" :new-tab="false"></SuggestedPost>
                </div>
              </div>
            </template>

            <!-- Show message if no users found --
            <div v-if="posts?.filter((p) => p?.celebrity === true).length == 0 && loading == false" class="text-sm italic text-[var(--color-text-02)] px-2 py-2">
              No Users Found
            </div>
          </div>
          <!-- <transition name="fade">
            <div v-if="showProTip"
              class="pro-tip-box bg-[var(--color-header-bg-light-v2)] border border-[var(--color-button-border)] rounded-[5px] px-[10px] py-[10px] shadow-sm">
              <div class="pro-tip">
                <div class="flex items-center gap-2 mb-2">
                  <span class="text-xl shrink-0">
                    <!-- 💡 --
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="23" viewBox="0 0 24 23" fill="none">
                      <path d="M12 14.3749C12.8333 14.3749 13.5417 14.0954 14.125 13.5364C14.7083 12.9773 15 12.2985 15 11.4999C15 10.7013 14.7083 10.0225 14.125 9.46346C13.5417 8.90443 12.8333 8.62492 12 8.62492C11.1667 8.62492 10.4583 8.90443 9.875 9.46346C9.29167 10.0225 9 10.7013 9 11.4999C9 12.2985 9.29167 12.9773 9.875 13.5364C10.4583 14.0954 11.1667 14.3749 12 14.3749ZM12 16.2916C10.6167 16.2916 9.4375 15.8244 8.4625 14.89C7.4875 13.9556 7 12.8256 7 11.4999C7 10.1742 7.4875 9.04419 8.4625 8.10981C9.4375 7.17544 10.6167 6.70825 12 6.70825C13.3833 6.70825 14.5625 7.17544 15.5375 8.10981C16.5125 9.04419 17 10.1742 17 11.4999C17 12.8256 16.5125 13.9556 15.5375 14.89C14.5625 15.8244 13.3833 16.2916 12 16.2916ZM5 12.4583H1V10.5416H5V12.4583ZM23 12.4583H19V10.5416H23V12.4583ZM11 4.79159V0.958252H13V4.79159H11ZM11 22.0416V18.2083H13V22.0416H11ZM6.4 7.427L3.875 5.10304L5.3 3.6895L7.7 6.08534L6.4 7.427ZM18.7 19.3103L16.275 16.8905L17.6 15.5728L20.125 17.8968L18.7 19.3103ZM16.25 6.13325L18.675 3.71346L20.15 5.07909L17.65 7.37909L16.25 6.13325ZM3.85 17.9208L6.375 15.5968L7.75 16.8666L5.325 19.2864L3.85 17.9208Z" 
                      :fill="isDark ? '#FFAD00' : '#001871'"/>
                    </svg>
                  </span>
                  <span class="text-[var(--color-accent-primary)] text-md font-bold">Pro Tip</span>
                </div>
                <!-- OLD: class="text-gray-400 hover:text-gray-600 ..." --
                <button @click="showProTip = false" class="text-[var(--color-text-muted)] hover:text-[var(--color-text-moderate)] transition mt-1 pr-1"
                  aria-label="Close">
                  <!-- ✖ -->
                  <!-- <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.29999 9.86401L3.95999 6.19201L1.70999 9.86401H-8.78423e-06L3.18599 4.96801L-8.78423e-06 1.29938e-05H1.85399L4.19399 3.65401L6.42599 1.29938e-05H8.13599L4.96799 4.87801L8.15399 9.86401H6.29999Z" 
                    :stroke="isDark ? '#fff' : '#001871'" />
                  </svg> --
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L4 12" :stroke="isDark ? '#fff' : '#001871'" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M4 4L12 12" :stroke="isDark ? '#fff' : '#001871'" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>

                </button>
              </div>
              <p class="text-sm text-[var(--color-tip-text)] leading-relaxed break-words whitespace-normal text-left">
                When you engage respectfully, your Civility Score rises - which allows you to give real feedback to
                other posts.
              </p>
            </div>
          </transition> -->
          <!-- <div
            class="bg-[var(--color-header-bg-light)] border border-[var(--color-button-border)] rounded-2xl px-[10px] py-[10px] shadow-sm flex flex-col gap-[0.5rem]">
            <h2 class="text-base font-bold mb-3 text-[var(--color-accent-primary)] text-left">Group Suggestions</h2>
            <div v-for="(group, i) in SuggestedGroups.slice(0, 4)" :key="i"
              class="flex items-start justify-between mb-3 last:mb-0 gap-1">
              <div class="flex items-center gap-1 flex-1 min-w-0">
                <div class="w-8 h-8 rounded-lg flex justify-center items-center text-white text-lg flex-shrink-0"
                  :class="group.color">
                  <img v-if="group.avatarFileId" :is="group.avatarFileId" :src="groupAvatar(group)" alt="group avatar"
                    class="w-10 h-10 rounded-full object-cover group-avatar" />
                  <img v-else src="/images/DefaultAvatar.svg" alt="default avatar"
                    class="w-full h-full rounded-full object-cover" />
                </div>
                <div class="text-wrapper flex-1 min-w-0">
                  <div class="group-name-link truncate cursor-pointer" @click.stop="handleUserClick(group)">{{ group.name }}</div>
                  <p class="text-xs text-[var(--color-member-text)] text-left">{{ group.members.length }}&nbsp;members</p>
                </div>
              </div>
              <div class="flex-shrink-0" style="width: 62px;">
                <button class="follow-btn" @click.prevent="toggleFollowGroup(group)" :aria-pressed="followingGroupIds.has(group.channelId || group.id)">
                  <span v-if="followingGroupIds.has(group.channelId || group.id)">Unfollow</span>
                  <span v-else>Follow</span>
                </button>
              </div>
            </div>

          </div> -->
        </div><!-- /nav-rightbar__scroll -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch, onBeforeUnmount } from 'vue';

// Mobile drawer — controlled by default.vue
/**
 * @prop {boolean} [mobileOpen] - Whether the right sidebar is open as a mobile slide-in drawer.
 */
const props = defineProps<{ mobileOpen?: boolean }>();
/**
 * @emits close - Requests the parent (default.vue) close the mobile drawer.
 */
const emit = defineEmits<{ (e: 'close'): void }>();
import { useStore } from 'vuex';
import ProgressSpinner from 'primevue/progressspinner';
import SuggestedPost from '../Post/SuggestedPost.vue';
import SuggestedPostCompact from '../Post/SuggestedPostCompact.vue';
import WhoToFollowCard from '@/components/Rightbar/WhoToFollowCard.vue';
import FollowedGroups from '@/components/ui-components/NewFollowedGroups/index.vue';
import QuickLinks from '@/components/ui-components/NewQuickLinks/index.vue';
import { useRouter, useRoute } from "vue-router";
import { useToast } from 'primevue/usetoast';
import { useUserRole } from '@/composables/useUserRole.js';

const store = useStore();
const route = useRoute();
const router = useRouter();
const toast = useToast();

const { canCreatePost } = useUserRole();

/** Toggles the global create/edit post modal open or closed. */
const setShowModal = (value: any) => store.dispatch('showModal', value);
/** Seeds the create/edit post modal with data for editing an existing post (or clears it with null). */
const setEditData = (data: any) => store.dispatch('addModalDataToState', data);
/** Sets whether the post modal is in "reply" mode. */
const setIsReply = (value: any) => store.dispatch('setIsReply', value);
/**
 * Opens the create-post modal for a brand-new post, guarded by the user's post-creation permission.
 * Resets reply/edit state first and refreshes the current user in the background.
 */
const openCreatePost = () => {
  if (!canCreatePost.value) return;
  setIsReply(false);
  setEditData(null);
  setShowModal(true);
  store.dispatch('getMe').catch(() => { });
};
/** Maps route names to the human-readable page title shown elsewhere in the layout. */
const pageTitleMap: Record<string, string> = {
  home: 'Community',
  search: 'Explore',
  groups: 'Groups',
  'user-groups': 'Groups',
  notifications: 'Messages',
  profile: 'Profile',
  username: 'Profile',
  org: 'Group',
  'dougjones-help': 'Help',
  followers: 'Followers',
  following: 'Following',
  channel: 'Channel',
  post: 'Post',
  reply: 'Reply',
  aboutPage: 'Quick Links',
};
/** Current route's display title, falling back to 'Community' for unmapped routes. */
const pageTitle = computed(() => {
  const name = route.name as string;
  return pageTitleMap[name] || 'Community';
});

/** Header text for the (currently unused, see template) community box; kept in sync with the active route. */
const communityBoxTitle = ref('Whats Happening in the Community');
/**
 * Updates `communityBoxTitle` whenever the route changes, picking a contextual
 * label (e.g. group vs. profile vs. notifications). Runs immediately on setup too.
 */
watch(
  () => route.name,
  (name) => {
    if (name === 'org' || name === 'groups' || name === 'group') communityBoxTitle.value = 'Whats Happening in the Group';
    else if (name === 'profile' || name === 'username') communityBoxTitle.value = 'Profile View';
    else if (name === 'notifications' || name === 'username') communityBoxTitle.value = 'Notifications';
    else if (name === 'referrals' || name === 'username') communityBoxTitle.value = 'Your Invitees';
    else if (name === 'aboutPage') communityBoxTitle.value = 'Quick Links';
    else communityBoxTitle.value = 'Whats Happening in the Community';
  },
  { immediate: true }
);

/** Whether the current user is authenticated. */
const isUserAuth = computed(() => store.getters.getAuthStatus);

// Merged from Leftbar: orgs data for FollowedGroups widget
/** Organizations/groups the user belongs to (for the merged FollowedGroups widget). */
const localOrgs = ref([]);
/** Whether `localOrgs` is still being fetched. */
const orgsLoading = ref(true);

/** Keeps `localOrgs` synced with the store's user-orgs getter as soon as it becomes available. */
watch(
  () => store.getters.getOnlyUserOrgs,
  (val) => { if (Array.isArray(val)) localOrgs.value = val; },
  { immediate: true }
);

/** Whether the (currently commented-out) Pro Tip banner is visible. */
const showProTip = ref(true);
/** Two-way bound global search text, backed by the Vuex store. */
const searchText = computed({
  get: () => store.getters.getSearchText,
  set: value => store.dispatch('updateSearchText', value),
});
/** Currently authenticated user's profile data. */
const userData = computed(() => store.getters.getAuthUser);
/** Whether suggested users/posts are currently being fetched. */
const loading = ref(false);

/** Dispatches the store action that refreshes suggested posts/users. */
const getSuggestedPosts = () => store.dispatch('setSuggestedPosts');
// Groups to Follow: show up to 4 groups from Browse Groups that the user has not yet joined.
// Data comes from fetchOtherOrgs (already dispatched in onMounted).
// OrgsItem handles Follow/Unfollow (public) and Join/Request Sent (private) internally.
const suggestedGroups = computed(() => {
  const raw = store.getters.getBrowseOrgs || [];
  const groups = Array.isArray(raw) ? raw : [];
  const userId = userData.value?.id;
  // Filter out groups the user is already a member of
  return groups
    .filter(g => !g.isPrivate)
    .filter(g => !joinedGroupIds.value.has(g.id))
    .filter(g => !userId || !(g.members || []).some((m: any) => m.userId === userId));
});

/**
 * Suggested users to show in "Who to Follow", derived from the store's suggested-posts
 * getter (accepting either a raw array or a `{ results }` wrapper), with users already
 * followed, the current user themself, and deleted users filtered out.
 */
const posts = computed(() => {
  const raw = store.getters.getSuggestedPosts;
  let suggestedUsers = [];
  if (Array.isArray(raw)) {
    suggestedUsers = raw;
  } else if (raw && Array.isArray(raw.results)) {
    suggestedUsers = raw.results;
  }

  // Filter out users that are already being followed
  const currentUser = userData.value;
  if (currentUser && currentUser.following && Array.isArray(currentUser.following)) {

    // console.error("Following Users:", currentUser.followin.length);

    const followingIds = new Set(currentUser.following);
    // Also exclude the current user themselves
    followingIds.add(currentUser.id);

    const filteredUsers = suggestedUsers.filter(user => {
      // Exclude followed users and self
      if (followingIds.has(user.id)) return false;

      // Exclude deleted users
      if (user.deletedAt) return false;

      return true;
    });

    // Limit to ~10 final suggestions
    return filteredUsers;
  }

  return suggestedUsers;
});

// Pagination state for the (legacy) inline search results lists.
const displayedUsers = ref([]); // Currently rendered slice of allUsers
const displayedPosts = ref([]); // Currently rendered slice of allPosts
const usersOffset = ref(0); // Next index to slice from in allUsers
const postsOffset = ref(0); // Next index to slice from in allPosts
const pageSize = 10; // Number of items loaded per "page"
const usersLoading = ref(false); // True while loadMoreUsers is fetching the next page
const postsLoading = ref(false); // True while loadMorePosts is fetching the next page
/** All matching users for the current search text. */
const allUsers = computed(() => store.getters.getSearchUsers);
/** All matching posts for the current search text. */
const allPosts = computed(() => store.getters.getSearchPosts);
/** All matching groups for the current search text. */
const allGroups = computed(() => store.getters.getSearchGroups || []);
/** Max groups shown before the (legacy) "Show more" toggle. */
const groupPageSize = 8;
/** Whether the (legacy) group search results list is expanded past `groupPageSize`. */
const showMoreGroups = ref(false);
/** Group search results, capped to `groupPageSize` unless expanded. */
const limitedGroups = computed(() => showMoreGroups.value ? allGroups.value : allGroups.value.slice(0, groupPageSize));
/** Channel ids the user currently follows (used to render Follow/Following state). */
const followingGroupIds = ref(new Set());

// Initialize followingGroupIds from the store's following channels so
// the UI reflects which groups the user already follows.
function initFollowingIds() {
  try {
    // Prefer the authoritative list from the org store, but fall back to
    // the authenticated user's followingChannels (some flows populate the
    // auth user before the org store is initialized).
    let following = store.getters.getFollowingChannels || [];
    if ((!Array.isArray(following) || following.length === 0) && userData && userData.value) {
      // normalize if userData stores followingChannels on the user profile
      following = userData.value.followingChannels || userData.value.following || [];
    }
    // following is an array of { channelId, followType } or simple ids
    const ids = (Array.isArray(following) ? following : []).map(f => (f && (f.channelId || f.id)) || f);
    followingGroupIds.value = new Set(ids.filter(Boolean));
  } catch (e) {
    followingGroupIds.value = new Set();
  }
}

// seed immediately
initFollowingIds();

// also react to changes in store-following list
/** Live view of the store's followed-channels list, used to detect changes below. */
const storeFollowingChannels = computed(() => store.getters.getFollowingChannels || []);
watch(storeFollowingChannels, () => initFollowingIds());
/** True while the user has typed search text and at least one result type has matches. */
const isSearchActive = computed(() => !!searchText.value && (allUsers.value.length || allPosts.value.length || allGroups.value.length));

// Accordion state (all closed by default after each search)
/** Open/closed state of each (legacy) search-results accordion section. */
const accordion = ref({ people: false, posts: false, groups: false });
/** Whether the user has manually toggled an accordion this search (vs. the default auto-closed state). */
const userAccordionInteraction = ref(false);
/** DOM refs to each accordion body, keyed by section, used for height measurement. */
const accordionBodies = ref({});

// function setAccordionBodyRef(key, el) { if (el) accordionBodies.value[key] = el; }

// const toggleAccordion = (key) => {
//   userAccordionInteraction.value = true;
//   accordion.value[key] = !accordion.value[key];
//   nextTick(() => updateBodyHeight(key));
// };

// Reset all closed when new results arrive
watch([allUsers, allPosts, allGroups, searchText], () => {
  if (!isSearchActive.value) {
    accordion.value = { people: false, posts: false, groups: false };
    userAccordionInteraction.value = false;
    return;
  }
  // On new search results, default closed
  accordion.value = { people: false, posts: false, groups: false };
  userAccordionInteraction.value = false;
  // Heights unnecessary since closed
});

/**
 * Sizes one (legacy) accordion body's max-height so it fits the remaining viewport
 * space when open, or collapses it to 0 when closed.
 * @param {string} key - Accordion section key ('people' | 'posts' | 'groups')
 */
function updateBodyHeight(key) {
  const el = accordionBodies.value[key];
  if (!el) return;
  if (!accordion.value[key]) {
    el.style.maxHeight = '0px';
    el.style.overflow = 'hidden';
    return;
  }
  el.style.maxHeight = 'none';
  // Make content visible while we measure and then constrain axes
  el.style.overflow = 'visible';
  const rect = el.getBoundingClientRect();
  const padding = 16; // space from bottom
  const available = window.innerHeight - rect.top - padding;
  const min = 160; // reasonable minimum
  const target = Math.max(min, available);
  el.style.maxHeight = target + 'px';
  el.style.overflowY = 'auto';
  el.style.overflowX = 'hidden';
}

/** Re-measures and resizes every accordion body (e.g. after a viewport resize). */
function updateAllHeights() { Object.keys(accordionBodies.value).forEach(updateBodyHeight); }
/** Window resize/orientation-change handler that keeps accordion heights in sync. */
function handleResize() { updateAllHeights(); }
/** On mount, loads browsable/other orgs (for group suggestions) and the user's own orgs (for the merged FollowedGroups widget). */
onMounted(async () => {
  await store.dispatch('fetchOtherOrgs');
  // Fetch orgs for the merged FollowedGroups widget
  await store.dispatch('fetchOnlyUserOrgs');
  orgsLoading.value = false;
});
/** Registers window resize/orientation listeners so accordion heights stay correct. */
onMounted(() => {
  window.addEventListener('resize', handleResize);
  window.addEventListener('orientationchange', handleResize);
});
/** Cleans up the resize/orientation listeners registered above. */
onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
  window.removeEventListener('orientationchange', handleResize);
});
// const noSearchResults = computed(() => store.getters.getNoSearchResults);
// const isDevelopment = computed(() => import.meta.env.MODE === 'development');

// // debounce-fetch search results when user types in the NavRightbar search
// const fetchSearchResults = debounce(async () => {
//   if (!searchText.value || !searchText.value.trim()) {
//     store.commit('clearSearchResults');
//     resetSearchLists();
//     return;
//   }
//   await store.dispatch('fetchSearchResults', searchText.value);
// }, 600);

/** Clears search results and resets pagination once the search box is emptied. */
watch(searchText, (val) => {
  if (!val || !val.trim()) {
    store.commit('clearSearchResults');
    resetSearchLists();
  }
});

// When search results (users) change, initialize pagination lists
watch(allUsers, (val) => {
  if (searchText.value && searchText.value.trim()) {
    displayedUsers.value = val.slice(0, pageSize);
    usersOffset.value = Math.min(pageSize, val.length);
  }
});

// When search results (posts) change, initialize pagination lists
watch(allPosts, (val) => {
  if (searchText.value && searchText.value.trim()) {
    displayedPosts.value = val.slice(0, pageSize);
    postsOffset.value = Math.min(pageSize, val.length);
  }
});
// const handleUserClick = (item) => {
//   const route = (`/group/${item?.id}`);
//   router.push(route);
// };
/** Resets the (legacy) paginated users/posts lists back to their first page. */
const resetSearchLists = () => {
  displayedUsers.value = allUsers.value.slice(0, pageSize);
  displayedPosts.value = allPosts.value.slice(0, pageSize);
  usersOffset.value = pageSize;
  postsOffset.value = pageSize;
};

/** Appends the next page of user search results to `displayedUsers` (simulated with a 1s delay). */
const loadMoreUsers = () => {
  if (usersOffset.value >= allUsers.value.length || usersLoading.value) return;

  usersLoading.value = true;
  setTimeout(() => {
    const nextUsers = allUsers.value.slice(usersOffset.value, usersOffset.value + pageSize);
    displayedUsers.value = [...displayedUsers.value, ...nextUsers];
    usersOffset.value += pageSize;
    usersLoading.value = false;
  }, 1000);
};

/** Appends the next page of post search results to `displayedPosts` (simulated with a 1s delay). */
const loadMorePosts = () => {
  if (postsOffset.value >= allPosts.value.length || postsLoading.value) return;

  postsLoading.value = true;
  setTimeout(() => {
    const nextPosts = allPosts.value.slice(postsOffset.value, postsOffset.value + pageSize);
    displayedPosts.value = [...displayedPosts.value, ...nextPosts];
    postsOffset.value += pageSize;
    postsLoading.value = false;
  }, 1000);
};

// const handlePostsScroll = e => {
//   const element = e.target;
//   if (element.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
//     loadMorePosts();
//   }
// };

// const handleUsersScroll = e => {
//   const element = e.target;
//   if (element.scrollTop + element.clientHeight >= element.scrollHeight - 10) {
//     loadMoreUsers();
//   }
// };

/** If the user is already authenticated at mount time, fetches suggested posts/users right away. */
onMounted(async () => {
  if (userData.value) {
    loading.value = true;
    await getSuggestedPosts();
    loading.value = false;
  }
});

/**
 * Toggles following/unfollowing a group (legacy path, superseded in the template by
 * the Join/Following buttons below), optimistically updating `followingGroupIds` and
 * refreshing the orgs list afterward.
 * @param {object} group - Group whose channelId/id identifies the channel to follow/unfollow
 */
const toggleFollowGroup = async (group) => {
  const channelId = group.channelId || group.id;
  if (!channelId) return;
  const isFollowing = followingGroupIds.value.has(channelId);
  if (isFollowing) {
    followingGroupIds.value.delete(channelId);
    await store.dispatch('fetchUnFollowChannel', { channelId });
  } else {
    followingGroupIds.value.add(channelId);
    await store.dispatch('fetchFollowChannel', { channelId, followType: 'follow' });
  }
  store.dispatch('fetchOtherOrgs');
};

// function formatGroupDesc(desc) {
//   if (!desc) return '';
//   const cleaned = desc.replace(/\s+/g, ' ').trim();
//   return cleaned.length > 110 ? cleaned.slice(0, 107) + '…' : cleaned;
// }
// function groupHandle(group) {
//   return group?.username || group?.handle || group?.slug || 'group';
// }
/** Whether the app is currently in dark scheme, read from the `scheme` attribute on `<html>`. */
const isDark = ref(false);
/** Re-reads the `scheme` attribute on `<html>` into `isDark`. */
function updateScheme() {
  try {
    isDark.value = (document?.documentElement?.getAttribute('scheme') === 'dark');
  } catch (_) {
    isDark.value = false;
  }
}
/** Sets the initial theme and watches the `<html>` element's `scheme` attribute for live theme changes. */
onMounted(() => {
  updateScheme();
  try {
    const obs = new MutationObserver(updateScheme);
    obs.observe(document.documentElement, { attributes: true, attributeFilter: ['scheme'] });
    onBeforeUnmount(() => obs.disconnect());
  } catch (_) { /* no-op */ }
});

/** Default group icon matching the current theme, used when a group has no avatar. */
function getGroupFallback() {
  return isDark.value ? '/icon/Groupsfill-dark.svg' : '/icon/Groupsfill.svg';
}

// function groupAvatar(group) {
//   return group?.avatarUrl || group?.imageUrl || group?.logoUrl || getGroupFallback();
// }

// function onGroupImgError(e) {
//   try {
//     const fallback = getGroupFallback();
//     const img = e?.target;
//     if (!img) return;
//     // Prevent infinite loop if fallback also fails
//     if (img.dataset.fallbackApplied === '1') return;
//     img.src = fallback;
//     img.dataset.fallbackApplied = '1';
//   } catch (_) {
//     // no-op
//   }
// }

// Tracks groups where a join request has been sent this session (optimistic UI)
const joinRequestedIds = ref(new Set<string>()); // Private groups the user has requested to join
const joiningGroupIds = ref(new Set<string>()); // Public groups mid-flight in a join request
const joinedGroupIds = ref(new Set<string>()); // Public groups optimistically marked as joined

// Public group: join directly (same flow as org.vue handleJoinGroup)
// OLD: added to joinedGroupIds only after the API responded, so the group
// stayed in the list until the round-trip finished.
// const handleGroupJoinPublic = async (group: any) => {
//   if (joiningGroupIds.value.has(group.id) || joinedGroupIds.value.has(group.id)) return;
//   joiningGroupIds.value.add(group.id);
//   try {
//     const res = await store.dispatch('fetchRequestToJoin', { id: group.id, skipToast: true });
//     if (res?.ok) {
//       joinedGroupIds.value.add(group.id);
//       toast.add({ severity: 'success', summary: 'Joined!', detail: `You have joined ${group.name}.`, life: 4000 });
//       store.dispatch('fetchOtherOrgs');
//     }
//   } finally {
//     joiningGroupIds.value.delete(group.id);
//   }
// };
/**
 * Joins a public group. Optimistic: marks the group as joined immediately so it
 * drops out of `suggestedGroups` on click, rolling back if the request fails so it
 * reappears with the Join button.
 */
// Optimistic: mark joined immediately so suggestedGroups drops the group on click;
// roll back if the request fails so it reappears with the Join button.
const handleGroupJoinPublic = async (group: any) => {
  if (joiningGroupIds.value.has(group.id) || joinedGroupIds.value.has(group.id)) return;
  joiningGroupIds.value.add(group.id);
  joinedGroupIds.value.add(group.id);
  try {
    const res = await store.dispatch('fetchRequestToJoin', { id: group.id, skipToast: true });
    if (res?.ok) {
      toast.add({ severity: 'success', summary: 'Joined!', detail: `You have joined ${group.name}.`, life: 4000 });
      store.dispatch('fetchOtherOrgs');
    } else {
      joinedGroupIds.value.delete(group.id);
    }
  } catch (e) {
    joinedGroupIds.value.delete(group.id);
  } finally {
    joiningGroupIds.value.delete(group.id);
  }
};

// Follow a public group
const handleGroupFollow = async (group: any) => {
  const channelId = group.channelId || group.id;
  if (!channelId) return;
  followingGroupIds.value.add(channelId);
  await store.dispatch('fetchFollowChannel', { channelId, followType: 'follow' });
  store.dispatch('fetchOtherOrgs');
};

// Unfollow a public group
const handleGroupUnfollow = async (group: any) => {
  const channelId = group.channelId || group.id;
  if (!channelId) return;
  followingGroupIds.value.delete(channelId);
  await store.dispatch('fetchUnFollowChannel', { channelId });
  store.dispatch('fetchOtherOrgs');
};

// Send join request for a private group
// OLD: no rollback — a failed request left the button stuck on "Requested"
// const handleGroupJoin = async (group: any) => {
//   if (joinRequestedIds.value.has(group.id)) return;
//   joinRequestedIds.value.add(group.id);
//   await store.dispatch('fetchRequestToJoin', group.id);
//   store.dispatch('fetchOtherOrgs');
// };
const handleGroupJoin = async (group: any) => {
  if (joinRequestedIds.value.has(group.id)) return;
  joinRequestedIds.value.add(group.id);
  try {
    const res = await store.dispatch('fetchRequestToJoin', group.id);
    if (res?.ok) store.dispatch('fetchOtherOrgs');
    else joinRequestedIds.value.delete(group.id);
  } catch (e) {
    joinRequestedIds.value.delete(group.id);
  }
};

// Reset follow cache when group search results change (keeps optimistic model simple)
watch(allGroups, () => {
  // when available groups change, re-sync following ids from store
  initFollowingIds();
});

// If auth status changes (login), fetch suggested posts automatically
watch(isUserAuth, async (val) => {
  if (val) {
    loading.value = true;
    await getSuggestedPosts();
    loading.value = false;
  }
});

// Watch userData: only fetch suggested posts when user first becomes available (login),
// not on every subsequent auth refresh (e.g. after modal close).
watch(userData, async (val, oldVal) => {
  if (val && !oldVal) {
    initFollowingIds();
    loading.value = true;
    await getSuggestedPosts();
    loading.value = false;
  } else if (val) {
    initFollowingIds();
  }
});

</script>

<style lang="scss">
.text-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.pro-tip {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
}

.scroll-box {
  overflow-y: auto;
  /* enables scroll functionality */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* Internet Explorer and Edge */
}

.scroll-box::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

.nav-rightbar {
  /* Offset variables for alignment; adjust here if needed */
  --rb-left-shift: 7px;
  /* left shift for search/accordions (aligned with search field) */
  --rb-right-extend: -54px;
  /* extend 12px more to the right */
  --rb-accordion-left: var(--rb-left-shift);
  --rb-accordion-right: 0px;
  /* no extension past nav-rightbar boundary */
  --rb-divider-inset: 60px;
  /* divider start after avatar */
  --rb-search-extra-right: 16px;
  /* additional right-side width for search (4px more) */
  // Use full available width within the layout constraints
  width: 100%;
  min-width: 200px;
  /* Minimum usable width */
  text-align: center;
  font-size: 14px;
  position: relative; // Use relative positioning
  overflow-x: hidden;
  /* Prevent horizontal overflow */

  // Ensure all nav-rightbar content respects width constraints
  * {
    max-width: 100%;
    box-sizing: border-box;
  }

  &__inner {
    // padding: 16px 16px 16px 8px; // minimal left padding for visual separation from centerbar
    position: sticky; // Use sticky positioning
    top: 0; // Default layout already adds padding-top equal to header height
    width: 100%;
    /* Use full container width */
    margin-left: 0;
    will-change: auto;
    isolation: isolate;
    display: flex;
    flex-direction: column;
    height: calc(100vh - var(--size-header-height, 80px) - 20px);
    max-height: calc(100vh - var(--size-header-height, 80px) - 20px);
    overflow: hidden;
    /* prevent outer scroll */
    z-index: 10;
    background: transparent;
    /* Remove background to show page background */
    border-radius: 0;
    /* Remove rounded corners */
    backdrop-filter: none;
    /* Remove blur effect */

    // Dark theme variant
    [scheme='dark'] & {
      background: transparent;
      /* Remove dark theme background */
    }

    // Simplified responsive padding - no more complex transforms
    @include _1279 {
      // padding: 16px 16px 16px 16px; // Simplified padding
    }

    @include _1024 {
      // padding: 20px 36px 20px 16px;
      // margin-left: 0; // Reset on mobile when nav-rightbar is hidden anyway
    }

    @include _767 {
      padding: 20px 32px 20px 16px;
    }

    @include _639 {
      padding: 10px 16px 20px 8px;
    }

    // Search placement and sizing
    &__search {
      margin-bottom: 10px;
    }

    &__search-input {
      display: block;
      width: 100%;
    }

    .post__username {
      max-width: none;
    }

    .nav-rightbar__posts-list {
      width: 100%;
    }
  }

  &__panel {
    display: flex;
    flex-direction: column;
    flex: 1 1 0;
    min-height: 0;
    overflow: hidden;
    background: transparent;
    border: none;
    border-radius: 0;
    // padding: 0px 0 0px;
    padding: 0px 15px 0px 5px;
    box-shadow: none;
    gap: 12px;
    position: relative;
  }

  [scheme='dark'] &__panel {
    background: transparent;
    box-shadow: none;
    border: none;
  }

  &__scroll {
    flex: 1 1 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    &::-webkit-scrollbar { display: none; }
  }

  &__posts {
    margin-top: 0;
    border-radius: 10px;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: visible;
    /* allow content to scroll within panel */

    @include _1024 {
      max-height: unset;
      max-width: 100%;
      margin: 20px auto 0;
    }

    &-list {
      background: var(--color-app-card-bg);
      border-radius: 10px;
      padding: 0; // flush content left
      width: 100%;
      // Allow independent scroll for search results (users/posts/groups)
      max-height: 360px;
      overflow-y: auto;
      overflow-x: hidden;
      scrollbar-width: thin;
      scrollbar-color: var(--color-surface-border, var(--border-primary)) transparent;

      &::-webkit-scrollbar {
        width: 6px;
      }

      &::-webkit-scrollbar-track {
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: var(--color-surface-border, var(--border-primary));
        border-radius: 3px;
      }

      .grow {
        max-width: 100%;
      }
    }
  }

  &__title {
    // font-family: 'ClashDisplay-Semibold';
    font-family: $poppins;
    line-height: 150%;
    color: var(--color-foreground-primary) !important;
  }

  &__suggested-block {
    background: var(--color-app-card-bg);
    border: 1px solid var(--color-surface-border, var(--border-primary));
    padding: 2px 0 4px 0; // compact vertical padding for stacked result blocks
    border-radius: 16px;
    /* Enable container queries for children (e.g., SuggestedPost) */
    container-type: inline-size;
    container-name: suggested-block;
    box-shadow: var(--color-surface-shadow-sm, 0 2px 4px -2px rgba(0, 0, 0, 0.06)), 0 1px 2px rgba(0, 0, 0, 0.04);
    backdrop-filter: blur(4px); // subtle frosted look on light backgrounds
    position: relative;
    max-height: 340px;
    /* default (non-search mode) */
    overflow-y: auto;
    /* default (non-search mode) */
    overflow-x: hidden;
    /* Prevent horizontal scrolling */
    margin-left: 7px;
    /* Adjusted shift: now 7px to the right */

    /* Hide scrollbars */
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */

    &::-webkit-scrollbar {
      display: none;
      /* Chrome, Safari and Opera */
    }
  }

  .suggested-wrapper {
    position: relative;
    padding: 0px 0px 0px 0px; // more comfortable vertical rhythm
    margin: 0; // remove side inset, align to container edge
    border-radius: 10px;
    transition: background .16s ease, box-shadow .16s ease;
    outline: none;

    // Divider line (skip last) starting after avatar column (~46px avatar + gap)
    &:not(:last-child)::after {
      content: '';
      position: absolute;
      left: var(--rb-divider-inset); // aligns after avatar to reduce visual noise
      right: 8px;
      bottom: 0;
      height: 1px;
      background: linear-gradient(to right, transparent, var(--color-surface-border, var(--color-box-border)) 30%, var(--color-surface-border, var(--color-box-border)) 70%, transparent);
      opacity: .55;
      pointer-events: none;
    }

    // Hover / focus states
    // &:hover {
    //   background: var(--color-app-card-bg-hover);
    // }

    &:focus-visible {
      background: var(--color-app-card-bg-hover);
      box-shadow: 0 0 0 2px var(--glow-color, rgba(59, 130, 246, 0.25));
    }

    // Provide a subtle pressed feedback
    // &:active {
    //   background: var(--color-hover-filter-tags-bg, rgba(0, 0, 0, 0.04));
    // }
  }

  // Dark theme tuning
  [scheme='dark'] .suggested-wrapper {
    &:not(:last-child)::after {
      opacity: .35;
    }

    &:hover {
      background: var(--color-app-card-bg-hover);
    }

    &:active {
      background: var(--color-app-card-bg-hover);
    }
  }

  .suggested-card {
    background: var(--color-app-card-bg);
    border: 1px solid var(--color-surface-border, var(--border-primary));
    border-radius: 10px;
    padding: 10px 12px;
    transition: background .18s ease, box-shadow .18s ease, border-color .18s ease;
    display: block;
    position: relative;

    &:hover {
      background: var(--color-app-card-bg-hover);
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
    }
  }

  [scheme='dark'] &__suggested-block {
    background: var(--color-app-card-bg);
    border-color: var(--color-surface-border, #2b3440);
    box-shadow: 0 2px 6px -2px rgba(0, 0, 0, 0.65), 0 1px 2px rgba(0, 0, 0, 0.4);
  }

  [scheme='dark'] .suggested-card {
    background: var(--color-app-card-bg);
    border-color: var(--color-surface-border, #2d3743);

    &:hover {
      background: var(--color-app-card-bg-hover);
    }
  }

  // Mobile responsiveness
  @include _1024 {
    width: 100%;
    max-width: 100%;
  }

  @include _767 {
    position: relative;
    top: 0;
  }
}

/* Accordion styles */
.accordion-results {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.accordion-section {
  border: 1px solid var(--color-surface-border, var(--border-primary));
  border-radius: 14px;
  background: var(--color-app-card-bg);
  overflow: hidden;
}

.accordion-header {
  width: 100%;
  text-align: left;
  background: transparent;
  border: none;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--color-foreground-primary);
}

.accordion-header:hover {
  background: var(--color-app-card-bg-hover);
}

.accordion-body {
  padding: 4px 0 10px 0;
  max-height: 0;
  overflow: hidden;
  transition: max-height .25s ease;
}

.chevron {
  display: inline-block;
  transform: rotate(90deg);
  transition: transform .25s ease;
  opacity: .65;
}

.chevron.open {
  transform: rotate(270deg);
  opacity: 1;
}

// Removed search-mode accordion visual tweaks
.nav-rightbar__posts-list.slim {
  max-height: 300px;
  overflow-y: auto;
  /* Hide scrollbars while keeping scroll functionality */
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.nav-rightbar__posts-list.slim::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

/* When accordion bodies become scrollable, also hide their scrollbars */
.accordion-body {
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE and Edge */
}

.accordion-body::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari, Opera */
}

/* Transition */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all .22s ease;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}

// Removed search-mode scroll overrides (revert to independent list scrolling)

/* Removed flush-left overrides inside accordion to restore original spacing */

/* Align search result blocks (People, Posts, Groups) with the search field edges */
.accordion-results {
  .accordion-section {
    margin-left: var(--rb-accordion-left) !important;
    /* shift whole section (header + list) to the right */
    margin-right: var(--rb-accordion-right) !important;
    /* extend section (header area) to the right */
  }

  .nav-rightbar__posts-list.nav-rightbar__suggested-block {
    /* Inside accordion: items should butt against the left border */
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  /* Remove inner wrapper insets so content aligns flush */
  .suggested-wrapper {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .group-wrapper {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .group-wrapper:not(:last-child)::after {
    left: var(--rb-divider-inset) !important;
  }

  .people-list {
    margin-left: 0 !important;
  }
}

/* Group results styling aligned to people list */
.groups-list {
  padding-top: 0;
}

.group-wrapper {
  padding: 10px 14px 12px 14px;
}

.group-wrapper:not(:last-child)::after {
  content: '';
  position: absolute;
  left: 60px;
  right: 8px;
  bottom: 0;
  height: 1px;
  background: linear-gradient(to right, transparent, var(--color-surface-border, var(--color-box-border)) 30%, var(--color-surface-border, var(--color-box-border)) 70%, transparent);
  opacity: .55;
}

[scheme='dark'] .group-wrapper:not(:last-child)::after {
  opacity: .35;
}

.group-name-link {
  font-weight: 600;
  font-size: 13px;
  line-height: 1.3;
  color: var(--color-foreground-primary);
  text-decoration: none;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.group-name-link:hover {
  text-decoration: underline;
}

.group-username {
  font-size: 12px;
  opacity: .75;
  line-height: 1.2;
  margin-top: 2px;
}

.group-desc {
  font-size: 12px;
  line-height: 1.35;
  margin-top: 4px;
  color: var(--color-foreground-secondary, var(--color-foreground-primary));
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.who-to-follow-scroll,
.groups-scroll,
.civil-voices-scroll {
  max-height: 240px;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar { display: none; }
}

.follow-btn {
  flex-shrink: 0;
  align-self: center;
  font-size: 0.8rem;
  font-weight: 500;
  // font-family: 'SFProText', serif;
  font-family: $poppins;
  // 9px 0px
  padding: 3px 8px;
  border-radius: 5.8px;
  border: 1px solid var(--color-button-border);
  background-color: var(--color-accent-primary);
  color: var(--color-text-black-white);
  line-height: 1;
  cursor: pointer;
  transition: background .2s ease, transform .15s ease;
  box-shadow: var(--button-shadow, 0 1px 2px rgba(0, 0, 0, 0.08));
  font-weight: 600;
  width: auto;
  max-width: 80px;
  min-width: 56px;
  white-space: nowrap;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.follow-btn:hover {
  // background: var(--color-brand-secondary-hover, #95d130);
  background-color: var(--color-accent-primary);
}

.follow-btn:active {
  /* OLD: background: var(--color-brand-secondary-active, #95d130); */
  background: var(--color-brand-secondary-active, var(--color-brand-lime-hover));
  transform: translateY(1px);
}

// [scheme='dark'] .follow-btn {
//   background: var(--color-brand-secondary, #a3e635);
//   color: var(--color-button-on-primary, #000);
// }

// [scheme='dark'] .follow-btn:hover {
//   background: var(--color-brand-secondary-hover, #95d130);
// }

.follow-btn span {
  display: inline-block;
}

.follow-btn:focus-visible {
  outline: 2px solid var(--color-focus-ring-outline, rgba(59, 130, 246, 0.55));
  outline-offset: 2px;
}

.follow-btn:not(:disabled).is-following {
  /* OLD: background: var(--color-brand-secondary, #a3e635); */
  background: var(--color-brand-secondary, var(--color-brand-lime));
}

.show-more-wrapper {
  text-align: center;
  margin: 6px 0 2px;
}

.show-more-btn {
  font-size: 12px;
  padding: 4px 10px;
  border-radius: 14px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: var(--color-foreground-primary);
}

.show-more-btn:hover {
  text-decoration: underline;
}

/* Light theme visibility adjustments for groups */
[scheme='light'] .group-name-link {
  /* OLD: color: var(--color-foreground-primary, #111); */
  color: var(--color-foreground-primary, var(--color-grey-quaternary));
}

[scheme='light'] .group-username {
  /* OLD: color: #555; */
  color: var(--color-grey-undenary);
  opacity: .85;
}

[scheme='light'] .group-desc {
  /* OLD: color: #5a5a5a; */
  color: var(--color-grey-octonary);
}

[scheme='light'] .group-wrapper:hover {
  background: var(--color-app-card-bg-hover);
}

/* Avatar border + unified fill */
.group-avatar {
  // border: 1px solid var(--color-surface-border, #d0d7de);
  // background: var(--color-app-card-bg);
}

[scheme='dark'] .group-avatar {
  // border-color: var(--color-surface-border, #2d3743);
  // background: var(--color-app-card-bg);
}
</style>

<style lang="scss" scoped>
.nav-rightbar__search,
.nav-rightbar__suggested-block {
  /* Reduce width by 16px, keep left edge the same */
  width: calc(100% - 16px) !important;
  /* If you have a max-width set elsewhere, also reduce it by 16px */
  max-width: calc(100% - 16px) !important;
}

.accordion-results .accordion-section {
  /* Ensure accordion sections stay within nav-rightbar bounds */
  width: calc(100% - var(--rb-accordion-left)) !important;
  max-width: calc(100% - var(--rb-accordion-left)) !important;
  box-sizing: border-box;
}
.community-box {
  border: 1px solid var(--color-header-border-light-v2);
  // border-left: none;
  // border-right: none;
  background: var(--color-header-bg-light-v2);
  box-shadow: 0 3.5px 4px 0 rgba(0, 0, 0, 0.05);
  color: var(--color-quick-link-icon-bg);
  font-weight: 600;
  height: 55px !important;
  border-radius: 6px;
}

.base-btn--small {
  max-height: 40px;
  min-width: 100%;
  padding: 8px 6px;
  font-size: 14px;
}

// ── Mobile drawer (right slide-in) ──────────────────────────────────────────
// Desktop: no change — all rules below only apply at ≤900px.
// MOBILE CHANGE 1d: solid themed background + release panel/scroll overflow so
//   Who to Follow, Discover Groups, Civil Voices, ProTip, Create Post all show.
@media (max-width: 900px) {
  .nav-rightbar {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 85%;
    max-width: 340px;
    z-index: 1300;
    transform: translateX(100%);
    transition: transform 0.28s cubic-bezier(0.4, 0, 0.2, 1);
    overflow-y: auto;
    overflow-x: hidden;
    background: var(--color-header-bg-light-v2);
    // Reset sticky/relative positioning from desktop
    &__inner {
      position: relative !important;
      top: auto !important;
      height: auto !important;
      max-height: none !important;
      overflow: visible !important;
    }
    // Desktop: overflow:hidden clips flex children. Release on mobile so content flows.
    &__panel {
      overflow: visible !important;
      height: auto !important;
      flex: none !important;
      min-height: auto !important;
    }
    &__scroll {
      height: auto !important;
      max-height: none !important;
      overflow: visible !important;
      padding-bottom: 80px;
    }
  }

  .nav-rightbar--mobile-open {
    transform: translateX(0);
  }

  .pro-tip-box {
    margin-bottom: 48px;
  }
}


// Close button — v-show controls visibility; this defines layout when visible
.nav-rightbar__mobile-close {
  display: flex;
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 10px 0px;
  background: var(--color-header-bg-light-v2);
  z-index: 1;
  border: none;
  cursor: pointer;
  color: var(--color-foreground-primary-v2);
  svg {
    width: 32px;
    height: 32px;
    padding: 5px;
    border-radius: 50%;
    background: var(--color-post-button-bg, rgba(0,0,0,0.06));
    &:hover { background: var(--color-background-btn-secondary); }
  }
}

// Who to Follow — name wraps, button absolutely pinned to bottom-right
// so it sits level with the @username row. SuggestedPost.vue is not touched.
// .who-to-follow-scroll .suggested-wrapper {
//   :deep(.suggested-post) {
//     height: auto !important;
//     min-height: unset;
//     position: relative;
//   }
//   :deep(.suggested-post__layout) {
//     align-items: flex-start;
//   }
//   :deep(.suggested-post__left) {
//     max-width: 100%;
//   }
//   // Pin button to bottom-right — level with the @username row
//   :deep(.suggested-post__right) {
//     position: absolute;
//     right: 10px;
//     bottom: 10px;
//     width: auto;
//   }
//   // Allow full name to use all available width, no truncation
//   :deep(.suggested-post__author-name) {
//     white-space: normal;
//     overflow: visible;
//     text-overflow: unset;
//     flex-shrink: 1;
//     max-width: 100%;
//   }
//   :deep(.suggested-post__author-name span) {
//     white-space: normal;
//     overflow: visible;
//     text-overflow: unset;
//     font-size: 13px;
//   }
//   // Only the username row needs right padding to avoid overlapping the button
//   :deep(.suggested-post__username) {
//     padding-right: 72px;
//     box-sizing: border-box;
//     max-width: 100%;
//     font-size: 12px;
//   }
//   // Compact button to match groups
//   :deep(.suggested-post__follow-button) {
//     padding: 3px 8px !important;
//     min-width: 56px;
//     max-width: 80px;
//     font-size: 0.78rem;
//     height: auto;
//   }
// }

// Backdrop behind the right drawer
.nav-rightbar-backdrop {
  display: none;
  @media (max-width: 900px) {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1299;
  }
}
</style>
